import axios, { type InternalAxiosRequestConfig, type AxiosInstance, AxiosResponse } from 'axios'

export const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const api: AxiosInstance = axios.create({ baseURL })

  api.interceptors.request.use(
    (config: InternalAxiosRequestConfig<any>) => {
      const token = localStorage.getItem('token')

      if (config.headers) {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }

        config.headers['Content-Type'] = config.data instanceof FormData ? 'multipart/form-data' : 'application/json'
      }

      return config
    },
    (error: any) => error,
  )

  api.interceptors.response.use(
    (response: AxiosResponse<any>) => {
      return response
    },
    async (error: any) => {
      if (error.response && error.response.status === 401) {
        document.dispatchEvent(new Event('session:expired'))
      }

      return error
    },
  )

  return api
}
